import { t } from 'i18next';

import {
  ExternalMaskingErrorPolicy,
  GuardrailBehavior,
  GuardrailErrorPolicy,
  RegexFlag,
} from '../../../../../gamma-api';
import { IbIconName } from '../../../../components/common/IbIcon';

import { CheckTypeValue, MaskingDetectorTypeValue } from './types';

export const getCheckTypeTitle = (type?: string): string => {
  if (type === CheckTypeValue.ExternalCheck) {
    return t('Agent: Guardrails: ExternalCheck: Title');
  }

  if (type === CheckTypeValue.RegexCheck) {
    return t('Agent: Guardrails: RegexCheck: Title');
  }

  if (type === CheckTypeValue.CustomPromptCheck) {
    return t('Agent: Guardrails: CustomPromptCheck: Title');
  }

  throw new Error(`Guardrail check type '${type}' is not supported`);
};

export const getCheckTypeDescription = (type?: string): string => {
  if (type === CheckTypeValue.ExternalCheck) {
    return t('Agent: Guardrails: ExternalCheck: Description');
  }

  if (type === CheckTypeValue.RegexCheck) {
    return t('Agent: Guardrails: RegexCheck: Description');
  }

  if (type === CheckTypeValue.CustomPromptCheck) {
    return t('Agent: Guardrails: CustomPromptCheck: Description');
  }

  throw new Error(`Guardrail check type '${type}' is not supported`);
};

export const getCheckTypeIconName = (type?: string): IbIconName => {
  if (type === CheckTypeValue.ExternalCheck) {
    return 'link-two';
  }

  if (type === CheckTypeValue.RegexCheck) {
    return 'code-brackets';
  }

  if (type === CheckTypeValue.CustomPromptCheck) {
    return 'robot-one';
  }

  throw new Error(`Guardrail check type '${type}' is not supported`);
};

export const getDetectorTypeTitle = (type?: string): string => {
  if (type === MaskingDetectorTypeValue.External) {
    return t('Agent: Guardrails: Masking: Detector: External: Title');
  }

  if (type === MaskingDetectorTypeValue.Regex) {
    return t('Agent: Guardrails: Masking: Detector: Regex: Title');
  }

  throw new Error(`Guardrail masking detector type '${type}' is not supported`);
};

export const getDetectorTypeDescription = (type?: string): string => {
  if (type === MaskingDetectorTypeValue.External) {
    return t('Agent: Guardrails: Masking: Detector: External: Description');
  }

  if (type === MaskingDetectorTypeValue.Regex) {
    return t('Agent: Guardrails: Masking: Detector: Regex: Description');
  }

  throw new Error(`Guardrail masking detector type '${type}' is not supported`);
};

export const getDetectorTypeIconName = (type?: string): IbIconName => {
  if (type === MaskingDetectorTypeValue.External) {
    return 'link-two';
  }

  if (type === MaskingDetectorTypeValue.Regex) {
    return 'code-brackets';
  }

  throw new Error(`Guardrail masking detector type '${type}' is not supported`);
};

export const getGuardrailBehaviorLabel = (behavior?: GuardrailBehavior): string => {
  if (behavior === GuardrailBehavior.Block) {
    return t('Agent: Guardrails: Step: Behavior: Block');
  }

  if (behavior === GuardrailBehavior.Allow) {
    return t('Agent: Guardrails: Step: Behavior: Allow');
  }

  throw new Error(`Guardrail behavior '${behavior}' is not supported`);
};

export const getGuardrailErrorPolicyLabel = (policy?: GuardrailErrorPolicy | ExternalMaskingErrorPolicy): string => {
  if (policy === GuardrailErrorPolicy.FailOpen || policy === ExternalMaskingErrorPolicy.FailOpen) {
    return t('Agent: Guardrails: ErrorPolicy: FailOpen');
  }

  if (policy === GuardrailErrorPolicy.FailClosed || policy === ExternalMaskingErrorPolicy.FailClosed) {
    return t('Agent: Guardrails: ErrorPolicy: FailClosed');
  }

  throw new Error(`Guardrail error policy '${policy}' is not supported`);
};

export const getRegexFlagLabel = (flag: RegexFlag): string => t(`Agent: Guardrails: RegexFlag: ${flag}`);
